export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["PROGRESS"] = "Progress";
    NotificationStatus["CREATED"] = "Created";
    NotificationStatus["RUNNING"] = "Running";
    NotificationStatus["COMPLETED"] = "Completed";
    NotificationStatus["FAILED"] = "Failed";
    NotificationStatus["CANCELED"] = "Canceled";
})(NotificationStatus || (NotificationStatus = {}));
